import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { KeyDisplayNamePipe } from '../../../../shared/components/stepper/pipes/key-display-name.pipe';
import { TagComponent } from '../../../../shared/components/tag/tag.component';
import { TableColumnsDataType } from '../../../../shared/enums/common';

export interface InfoCardItem {
  name: string;
  value: any;
  type?: string;
  isTag?: boolean;
  tagSeverity?: 'secondary' | 'success' | 'info' | 'progress' | 'warning' | 'pending' | 'help' | 'danger';
}

@Component({
  selector: 'app-info-card',
  standalone: true,
  imports: [CommonModule, TagComponent, KeyDisplayNamePipe],
  templateUrl: './info-card.component.html',
  styleUrl: './info-card.component.scss',
})
export class InfoCardComponent {
  readonly data = input<InfoCardItem[]>([]);
  tableColumnsDataType = TableColumnsDataType;
}
